import React, { useEffect } from 'react';
import { Stack } from '@starrez/starryui9';
import { useSentry } from '@starrez/starryutils';
import { strings } from '../../.localisation';
import styled from 'styled-components';
import { scheme } from '@starrez/starrytheme';

declare let SEND_TO_SENTRY: boolean;

export interface IErrorDisplayProps {
    error: Error | undefined;
}

export const ErrorDisplay = ({ error }: IErrorDisplayProps) => {
    const { captureException } = useSentry();

    useEffect(() => {
        if (SEND_TO_SENTRY && error) {
            captureException(error);
        }
    }, [error]);

    return (
        <Stack pad="large">
            <WrapperDiv>
                <Stack pad="xSmall">
                    {error ? <pre role="alert">{JSON.stringify(error, undefined, 2)}</pre> : <p role="alert">{strings.Message_UnknownError}</p>}
                </Stack>
            </WrapperDiv>
        </Stack>
    );
};

const WrapperDiv = styled.div`
    ${(_) => ({ ...scheme.Red.Lighter })}
    border-radius: 4px;
`;
